<template>
  <div class="row">
    <h3 class="mb-20">Statistiques Générals</h3>
    <div class="col-md-4 col-sm-6">
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center">
            <div
              class="icon position-relative rounded-circle text-center text-primary"
            >
              <i class="flaticon-sterile-box"></i>
            </div>
            <div class="title ms-15">
              <span
                class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis"
              >
                Total Colis
              </span>
              <h4 class="fw-black mb-8 lh-1">
                {{ dashData?.totalParcels ?? 0 }}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-4 col-sm-6">
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center">
            <div
              class="icon position-relative rounded-circle text-center text-success"
            >
              <i class="flaticon-sterile-box"></i>
            </div>
            <div class="title ms-15">
              <span
                class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis"
              >
                Total Colis livrés
              </span>
              <h4 class="fw-black mb-8 lh-1">
                {{ dashData?.totalParcels_livred ?? 0 }}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-4 col-sm-6">
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center">
            <div
              class="icon position-relative rounded-circle text-center text-info"
            >
              <i class="flaticon-sterile-box"></i>
            </div>
            <div class="title ms-15">
              <span
                class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis"
              >
                Total Colis Reportés Aujourd'hui
              </span>
              <h4 class="fw-black mb-8 lh-1">
                {{ dashData?.POSTPONED ?? 0 }}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <div class="card mb-25 border-0 rounded-0 mb-20">
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
          <div
            class="mb-15 mb-sm-0 d-sm-flex align-items-center justify-content-between"
          >
            <div class="title">
              <h5 class="card-title fw-black mb-0">Votre Taux de livraiosn</h5>
            </div>
          </div>
          <div class="col-md-8">
            <div>
              <div class="chart">
                <apexchart
                  type="radialBar"
                  height="200"
                  :options="goalOverviewRadialBar"
                  :series="goalOverviewRadialBar.series"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <!-- <div class="col-md-6">
      <div class="card mb-25 border-0 rounded-0 mb-20">
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
          <div
            class="mb-15 mb-sm-0 d-sm-flex align-items-center justify-content-between"
          >
            <div class="title">
              <h5 class="card-title fw-black mb-0">
                {{ dashData?.parcelsLivreurTotal ?? 0 }} Colis
              </h5>
            </div>
          </div>
          <div class="col-md-8">
            <div>
              <div class="chart">
                <apexchart
                  type="line"
                  height="325"
                  :options="statisticsProfit.chartOptions"
                  :series="chartData"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <div class="col-md-2 col-sm-6">
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center">
            <div
              class="icon position-relative rounded-circle text-center"
              :style="{
                color:
                  dashData?.ParcelsStatus?.DISTRIBUTION?.color + ' !important',
              }"
            >
              <i class="flaticon-sterile-box"></i>
            </div>
            <div class="title ms-15">
              <span
                class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis"
              >
                {{
                  dashData?.ParcelsStatus?.DISTRIBUTION?.name ??
                  "En Distribution"
                }}
              </span>
              <h4 class="fw-black mb-8 lh-1">
                {{ dashData?.ParcelsStatus?.DISTRIBUTION?.num ?? 0 }}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-2 col-sm-6">
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center">
            <div
              class="icon position-relative rounded-circle text-center"
              :style="{
                color:
                  dashData?.ParcelsStatus?.IN_PROGRESS?.color + ' !important',
              }"
            >
              <i class="flaticon-sterile-box"></i>
            </div>
            <div class="title ms-15">
              <span
                class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis"
              >
                {{ dashData?.ParcelsStatus?.IN_PROGRESS?.name ?? "En Cours" }}
              </span>
              <h4 class="fw-black mb-8 lh-1">
                {{ dashData?.ParcelsStatus?.IN_PROGRESS?.num ?? 0 }}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="col-md-2 col-sm-6">
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center">
            <div
              class="icon position-relative rounded-circle text-center"
              :style="{
                color:
                  dashData?.ParcelsStatus?.DELIVERED?.color + ' !important',
              }"
            >
              <i class="flaticon-sterile-box"></i>
            </div>
            <div class="title ms-15">
              <span
                class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis"
              >
                {{ dashData?.ParcelsStatus?.DELIVERED?.name ?? "Livrés" }}
              </span>
              <h4 class="fw-black mb-8 lh-1">
                {{ dashData?.ParcelsStatus?.DELIVERED?.num ?? 0 }}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-2 col-sm-6">
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center">
            <div
              class="icon position-relative rounded-circle text-center"
              :style="{
                color: dashData?.ParcelsStatus?.REFUSE?.color + ' !important',
              }"
            >
              <i class="flaticon-sterile-box"></i>
            </div>
            <div class="title ms-15">
              <span
                class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis"
              >
                {{ dashData?.ParcelsStatus?.REFUSE?.name ?? "Refusés" }}
              </span>
              <h4 class="fw-black mb-8 lh-1">
                {{ dashData?.ParcelsStatus?.REFUSE?.num ?? 0 }}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-2 col-sm-6">
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center">
            <div
              class="icon position-relative rounded-circle text-center"
              :style="{
                color: dashData?.ParcelsStatus?.RETURNED?.color + ' !important',
              }"
            >
              <i class="flaticon-sterile-box"></i>
            </div>
            <div class="title ms-15">
              <span
                class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis"
              >
                {{ dashData?.ParcelsStatus?.RETURNED?.name ?? "Retournés" }}
              </span>
              <h4 class="fw-black mb-8 lh-1">
                {{ dashData?.ParcelsStatus?.RETURNED?.num ?? 0 }}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
      <div class="col-md-6">
        <div class="card mb-25 border-0 rounded-0 bg-white">
          <div class="card-header">
            <h6 class="card-title">Total Bons Paiment Payé (Livreur)</h6>
            <h6 class="mb-25 fw-black">
              {{ dashData?.totalNotePaid ?? 0 }} Bons
            </h6>
          </div>
          <div class="card-body">
            <div
              class="mb-20 d-flex align-items-center justify-content-between"
            >
              <div class="d-flex align-items-center">
                <div
                  class="icon position-relative rounded-circle text-center bg-success text-white me-15"
                  style="
                    width: 42px;
                    height: 42px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <i class="flaticon-sterile-box"></i>
                </div>
                <div>
                  <h6 class="mb-0 fw-medium">Colis</h6>
                  <small class="text-muted">Total Colis</small>
                </div>
              </div>
              <div class="fw-black">
                {{ dashData?.payn_l_parcels ?? 0 }} Colis
              </div>
            </div>
            <div
              class="mb-20 d-flex align-items-center justify-content-between"
            >
              <div class="d-flex align-items-center">
                <div
                  class="icon position-relative rounded-circle text-center bg-danger text-white me-15"
                  style="
                    width: 42px;
                    height: 42px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <i class="flaticon-money"></i>
                </div>
                <div>
                  <h6 class="mb-0 fw-medium">Crbt</h6>
                  <small class="text-muted">Total Crbt</small>
                </div>
              </div>
              <div class="fw-black">
                {{ dashData?.payn_l_crbt ?? 0 }}
                {{ dashData?.devis?.devis ?? "" }}
              </div>
            </div>
            <div
              class="mb-20 d-flex align-items-center justify-content-between"
            >
              <div class="d-flex align-items-center">
                <div
                  class="icon position-relative rounded-circle text-center bg-primary text-white me-15"
                  style="
                    width: 42px;
                    height: 42px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <i class="flaticon-express-delivery"></i>
                </div>
                <div>
                  <h6 class="mb-0 fw-medium">Frais</h6>
                  <small class="text-muted">Total Frais</small>
                </div>
              </div>
              <div class="fw-black">
                {{ dashData?.payn_l_fees ?? 0 }}
                {{ dashData?.devis?.devis ?? "" }}
              </div>
            </div>
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <div
                  class="icon position-relative rounded-circle text-center bg-info text-white me-15"
                  style="
                    width: 42px;
                    height: 42px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <i class="flaticon-money"></i>
                </div>
                <div>
                  <h6 class="mb-0 fw-medium">Total</h6>
                  <small class="text-muted">Total</small>
                </div>
              </div>
              <div class="fw-black text-danger">
                {{ dashData?.payn_l_total ?? 0 }}
                {{ dashData?.devis?.devis ?? "" }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="card mb-25 border-0 rounded-0 bg-white">
          <div class="card-header">
            <h6 class="card-title">Total Bons Paiment Non Payé (Livreur)</h6>
            <h6 class="mb-25 fw-black">
              {{ dashData?.totalNoteNotPaid ?? 0 }} Bons
            </h6>
          </div>
          <div class="card-body">
            <div
              class="mb-20 d-flex align-items-center justify-content-between"
            >
              <div class="d-flex align-items-center">
                <div
                  class="icon position-relative rounded-circle text-center bg-success text-white me-15"
                  style="
                    width: 42px;
                    height: 42px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <i class="flaticon-sterile-box"></i>
                </div>
                <div>
                  <h6 class="mb-0 fw-medium">Colis</h6>
                  <small class="text-muted">Total Colis</small>
                </div>
              </div>
              <div class="fw-black">
                {{ dashData?.payn_l_not_parcels ?? 0 }} Colis
              </div>
            </div>
            <div
              class="mb-20 d-flex align-items-center justify-content-between"
            >
              <div class="d-flex align-items-center">
                <div
                  class="icon position-relative rounded-circle text-center bg-danger text-white me-15"
                  style="
                    width: 42px;
                    height: 42px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <i class="flaticon-money"></i>
                </div>
                <div>
                  <h6 class="mb-0 fw-medium">Crbt</h6>
                  <small class="text-muted">Total Crbt</small>
                </div>
              </div>
              <div class="fw-black">
                {{ dashData?.payn_l_not_crbt ?? 0 }}
                {{ dashData?.devis?.devis ?? "" }}
              </div>
            </div>
            <div
              class="mb-20 d-flex align-items-center justify-content-between"
            >
              <div class="d-flex align-items-center">
                <div
                  class="icon position-relative rounded-circle text-center bg-primary text-white me-15"
                  style="
                    width: 42px;
                    height: 42px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <i class="flaticon-express-delivery"></i>
                </div>
                <div>
                  <h6 class="mb-0 fw-medium">Frais</h6>
                  <small class="text-muted">Total Frais</small>
                </div>
              </div>
              <div class="fw-black">
                {{ dashData?.payn_l_not_fees ?? 0 }}
                {{ dashData?.devis?.devis ?? "" }}
              </div>
            </div>
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <div
                  class="icon position-relative rounded-circle text-center bg-info text-white me-15"
                  style="
                    width: 42px;
                    height: 42px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <i class="flaticon-money"></i>
                </div>
                <div>
                  <h6 class="mb-0 fw-medium">Total</h6>
                  <small class="text-muted">Total</small>
                </div>
              </div>
              <div class="fw-black text-danger">
                {{ dashData?.payn_l_not_total ?? 0 }}
                {{ dashData?.devis?.devis ?? "" }}
              </div>
            </div>
          </div>
        </div>
      </div>

  </div>
</template>
<script lang="ts">
import { useAuthStore } from "@/stores/auth";
import api from "@/utils/axios";
import { defineComponent, onMounted, ref } from "vue";

export default defineComponent({
  setup() {
    const dashData = ref<any>({});
    const auth = useAuthStore();
    const user = auth.user;

    const dd = ref([{ data: [] }]);

    const date_filter = ref("");
    const searchEDate = ref("");
    const searchSDate = ref("");

    const goalOverviewRadialBar = ref({
      series: [dashData.value?.deliveryRate ?? 0],
      chart: {
        height: 245,
        type: "radialBar",
        sparkline: {
          enabled: true,
        },
        dropShadow: {
          enabled: true,
          blur: 3,
          left: 1,
          top: 1,
          opacity: 0.1,
        },
      },
      colors: ["#7367F0"], // Replace with your desired color
      plotOptions: {
        radialBar: {
          offsetY: -10,
          startAngle: -150,
          endAngle: 150,
          hollow: {
            size: "77%",
          },
          track: {
            background: "#e7e7e7", // Replace with your desired color
            strokeWidth: "50%",
          },
          dataLabels: {
            name: {
              show: false,
            },
            value: {
              color: "#222f3e", // Replace with your desired color
              fontSize: "2.86rem",
              fontWeight: "600",
            },
          },
        },
      },
      fill: {
        type: "gradient",
        gradient: {
          shade: "dark",
          type: "horizontal",
          shadeIntensity: 0.5,
          gradientToColors: ["#28C76F"], // Replace with your desired color
          inverseColors: true,
          opacityFrom: 1,
          opacityTo: 1,
          stops: [0, 100],
        },
      },
      stroke: {
        lineCap: "round",
      },
      grid: {
        padding: {
          bottom: 30,
        },
      },
    });


    const chartData = ref([
      {
        name: "Colis",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
    ]);
    const statisticsProfit = {
      chartOptions: {
        chart: {
          type: "line",
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
        },
        title: {
          text: "Évolution des Colis (9 derniers jours)",
          align: "left",
          style: {
            fontSize: "13px",
            fontWeight: 600,
          },
        },
        grid: {
          borderColor: "#e9ecef", // Replace $trackBgColor with a color value
          strokeDashArray: 5,
          xaxis: {
            lines: {
              show: true,
            },
          },
          yaxis: {
            lines: {
              show: true,
            },
          },
          padding: {
            top: 0,
            bottom: 0,
          },
        },
        stroke: {
          width: 3,
          curve: "smooth",
        },
        colors: ["#17a2b8"], // Replace $themeColors.info with a color value
        markers: {
          size: 4,
          colors: "#17a2b8",
          strokeColors: "#ffffff",
          strokeWidth: 2,
          strokeOpacity: 1,
          strokeDashArray: 0,
          fillOpacity: 1,
          shape: "circle",
          hover: {
            size: 6,
          },
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          categories: [
            "J-8",
            "J-7",
            "J-6",
            "J-5",
            "J-4",
            "J-3",
            "J-2",
            "J-1",
            "Aujourd'hui",
          ],
          labels: {
            show: true,
            style: {
              fontSize: "11px",
            },
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
        },
        yaxis: {
          show: true,
          min: 0,
          forceNiceScale: true,
          labels: {
            formatter: (val: number) => Math.round(val).toString(),
            style: {
              fontSize: "11px",
            },
          },
        },
        tooltip: {
          x: {
            show: true,
          },
          y: {
            formatter: (val: number) => `${val} Colis`,
          },
        },
      },
    };
    const getData = async () => {
      await api
        .get(
          `/api/auth/StatisticParcels?user_id=${user?.id}&searchSDate=${searchSDate.value}&searchEDate=${searchEDate.value}`
        )
        .then((response: { data: any }) => {
          dashData.value = response.data;
          chartData.value[0].data = response.data.DataParcels;
          // dd.value[0].data = response.data.DataParcels;
          // isLoader.value = false;
        });
    };

    onMounted(() => {
      getData();
      try {
        api.get(`/api/auth/TauxLivreur`).then((response) => {
          goalOverviewRadialBar.value.series = [response.data.percent];
        });
      } catch (error) {
        console.error("Error updating series:", error);
      }
    });

    const FilterData = () => {
      getData();
    };

    const ClearFilterData = () => {
      searchEDate.value = "";
      searchSDate.value = "";
      getData();
    };
    return {
      dashData,
      dd,
      date_filter,
      searchEDate,
      searchSDate,
      getData,
      FilterData,
      ClearFilterData,
      goalOverviewRadialBar,
      user,
      chartData,
      statisticsProfit
    };
  },
});
</script>
